import { useState, useEffect } from "react";
import { AuthClient } from "@anythink-cloud/sdk";

export function useAuthStoreHydration(authClient: AuthClient) {
  const [storeHydrated, setStoreHydrated] = useState(false);

  // Wait for store to finish hydrating to avoid race conditions on mount
  useEffect(() => {
    const store = authClient.getStore();
    const persistApi = (store as any).persist;
    if (persistApi?.hasHydrated()) {
      setStoreHydrated(true);
      return;
    }
    const unsub = persistApi?.onFinishHydration(() => {
      setStoreHydrated(true);
    });
    return unsub;
  }, [authClient]);

  return { storeHydrated };
}
